type AuthorizationCredentials = {
	token?: string | null;
	tokenVerify?: string | null;
	authorizationType?: string | null;
};

export const createAuthorizationHeaders = (
	{ token, tokenVerify, authorizationType }: AuthorizationCredentials,
	init?: HeadersInit,
) => {
	const headers = new Headers(init);

	headers.set("Authorization", `Bearer ${token ?? ""}`);
	headers.set("token-verify", tokenVerify ?? "");
	if (authorizationType) {
		headers.set("Authorization-type", authorizationType);
	}

	return headers;
};
